// extracted by mini-css-extract-plugin
export default {"bar":"SaveSegmentBar_bar__8V6zW","label":"SaveSegmentBar_label__lnC48","input":"SaveSegmentBar_input__tIM9E","saveBtn":"SaveSegmentBar_saveBtn__akMTe"};